import { Box, Icon, Text } from '@nimbus-ds/components';
import { CheckCircleIcon, StopIcon } from '@nimbus-ds/icons';

export interface Feature {
  text: string;
  checked: boolean;
}

interface FeatureListProps {
  features: Feature[];
}

export default function FeatureList({ features }: Readonly<FeatureListProps>) {
  return (
    <Box display="flex" flexDirection="column" gap="1">
      {features.map(({ text, checked }) => (
        <Box key={text} display="flex" flexDirection="row" gap="1">
          {checked ? (
            <Icon
              color="success-textLow"
              source={<CheckCircleIcon size={14} />}
            />
          ) : (
            <Icon color="danger-textLow" source={<StopIcon size={14} />} />
          )}
          <Text
            fontSize="caption"
            color={checked ? 'success-textLow' : 'danger-textLow'}
          >
            {text}
          </Text>
        </Box>
      ))}
    </Box>
  );
}
